import { render, staticRenderFns } from "./_base-list-filters-address-type-types.vue?vue&type=template&id=9d4f37ec&"
import script from "./_base-list-filters-address-type-types.vue?vue&type=script&lang=js&"
export * from "./_base-list-filters-address-type-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports